import { GET_SERVER_DATES } from "requests"

const getProps = (props = {}) => {
  return {
    errorMessage: { type: "text", value: "", label: "Error Message" },
    ...props
  }
}

const getDateOptions = callback => {
  GET_SERVER_DATES(dates => {
    callback(dates.map(date => ({ value: date.ID, label: date.LABEL })))
  }, err => {
    console.error(err)
    callback([])
  })
}

export const BUSINESS_RULES = {
  notEmptyOrNull: {
    name: "Field cannot be empty",
    fn: "notEmptyOrNull",
    onAdvance: true,
    onBlur: true,
    props: getProps()
  },
  mustBeSelected: {
    name: "Must select an option",
    fn: "mustBeSelected",
    onChange: true,
    onAdvance: true,
    props: getProps()
  },
  numberLessThan: {
    name: "Number must be less than or equal to",
    fn: "numberLessThan",
    onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      max: { type: "float", value: 0, label: "Maximum Value" }
    })
  },
  numberGreaterThan: {
    name: "Number must be greater than or equal to",
    fn: "numberGreaterThan",
    onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      min: { type: "float", value: 0, label: "Minimum Value" }
    })
  },
  mustBeTrue: {
    name: "Field must be checked",
    fn: "mustBeTrue",
    onChange: true,
    onAdvance: true,
    props: getProps()
  },
  valuesMatch: {
    name: "Fields must match",
    fn: "valuesMatch",
    onBlur: true,
    onAdvance: true,
    props: getProps({
      caseSensitive: { type: "checkbox", value: true, label: "Case Sensitive" }
    })
  },
  mustNotEqualString: {
    name: "Field must not equal string",
    fn: "mustNotEqualString",
    onChange: true,
    onAdvance: true,
    props: getProps({
      caseSensitive: { type: "checkbox", value: true, label: "Case Sensitive" }
    })
  },
  addressIsRequired: {
    name: "Full address is required",
    fn: "addressIsRequired",
    onAdvance: true,
    props: getProps()
  },
  addressIsValid: {
    name: "Must be a valid USPS address if entered",
    fn: "addressIsValid",
    onAdvance: true,
    props: getProps({
        ...(process.env.ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && {allowAddressValidationBypass: {
            type: "checkbox",
            value: !!process.env.DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED,
            label: "Allow user to bypass address validation when invalid address is entered. NOTE: This is intended to be used for mailing addresses, and is tracked as such in the database."
          }})
        })
  },
  partialAddressNotAllowed: {
    name: "Partial addresses are not allowed",
    description:
      "This rule has the effect of disallowing a partially completed address, but will allow an empty address. Cannot be used with AMS address validation rules.",
    fn: "partialAddressNotAllowed",
    onAdvance: true,
    props: getProps()
  },
  registeredAgentAddressIsValid: {
    name: "Agent name and Physical address is required if adding new agent",
    fn: "registeredAgentAddressIsValid",
    onAdvance: true,
    props: getProps(
      {
        principalAddressAMS: {
          type: "checkbox",
          value: process.env.RA_PRINCIPAL_ADDRESS_AMS || false,
          label: "Require that the street address be a valid AMS address."
        },
        ...(process.env.ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && {allowAgentAddressPrimaryValidationBypass: {
            type: "checkbox",
            value: !!process.env.DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED,
            label: "Allow user to bypass street address validation when invalid address is entered."
          }}),
        mailingAddressRequired: {
          type: "checkbox",
          value: false,
          label: "Require that the mailing address be a valid AMS address.",
        },
        ...(process.env.ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && {allowAgentAddressMailValidationBypass: {
            type: "checkbox",
            value: !!process.env.DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED,
            label: "Allow user to bypass mailing address validation when invalid address is entered."
          }})
      }
    )
  },
  registeredAgentIsRequired: {
    name: "Registered agent is required",
    fn: "registeredAgentIsRequired",
    onAdvance: true,
    props: getProps()
  },
  registeredAgentNotSoS: {
    name: "Agent must not be the Secretary of State",
    fn: "registeredAgentNotSoS",
    onAdvance: true,
    props: {}
  },
  noRegulatedWords: {
    name: "Regulated words not allowed",
    fn: "noRegulatedWords",
    deprecated: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      filingTypeId: {
        type: "fieldSrc",
        value: "",
        label: "Override FILING_TYPE_ID with value from field:",
        emptyOptionLabel: "[Use default FILING_TYPE_ID]"
      }
    })
  },
  hasNameEnding: {
    name: "Must contain proper name designation",
    fn: "hasNameEnding",
    deprecated: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      filingTypeId: {
        type: "fieldSrc",
        value: "",
        label: "Override FILING_TYPE_ID with value from field:",
        emptyOptionLabel: "[Use default FILING_TYPE_ID]"
      }
    })
  },
  nameNotTaken: {
    name: "Name must be unique",
    fn: "nameNotTaken",
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  repeaterMinRows: {
    name: "Must add a minimum number of rows",
    fn: "repeaterMinRows",
    onAdvance: true,
    props: getProps({
      minRows: {
        type: "range",
        value: 0,
        label: "Minimum Number of Rows",
        minValue: 0,
        maxValue: 50,
        step: 1
      },
      noRowsIsValid: {
        type: "checkbox",
        value: false,
        label: "The minimum rows are only required if at least one row has been added."
      }
    })
  },
  repeaterMaxRows: {
    name: "Only allow a maximum number of rows",
    fn: "repeaterMaxRows",
    onAdvance: true,
    props: getProps({
      maxRows: {
        type: "range",
        value: 10,
        label: "Maximum Number of Rows",
        minValue: 0,
        maxValue: 50,
        step: 1
      }
    })
  },
  validateRepeaterFields: {
    name: "Validate all repeater rows on advance",
    fn: "validateRepeaterFields",
    onAdvance: true,
    props: {
      skipDeletedRows: {
        type: "checkbox",
        value: false,
        label: "Do not validate deleted rows"
      }
    }
  },
  validateThirdPartySignaturesRepeater: {
    name: "Validate all 3rd party signature repeater rows on advance",
    fn: "validateThirdPartySignaturesRepeater",
    onAdvance: true,
    props: {}
  },
  nameRequired: {
    name: "Name is required",
    fn: "nameRequired",
    onBlur: true,
    onAdvance: true,
    props: getProps({
      onlyLastNameRequired: {
        type: "checkbox",
        value: false,
        label: "Only last name is required"
      }
    })
  },
  nameOrgRequired: {
    name: "Must not be empty or null",
    fn: "nameOrgRequired",
    onBlur: true,
    onAdvance: true,
    props: getProps({
      onlyLastNameRequired: {
        type: "checkbox",
        value: false,
        label: "Only last name is required"
      }
    })
  },
  searchItemRequired: {
    name: "Must select an item from the search",
    fn: "searchItemRequired",
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  nameQualifiedOrgRequired: {
    name: "Must not be empty or null",
    fn: "nameQualifiedOrgRequired",
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  validFeinNum: {
    name: "Must be a correctly formatted FEIN",
    fn: "validFeinNum",
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  validPhoneNumber: {
    name: "Must be a correctly formatted phone number",
    fn: "validPhoneNumber",
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  validPhoneNumberIfPresent: {
    name: "Must be a correctly formatted phone number if provided.",
    fn: "validPhoneNumberIfPresent",
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  enforceMaxDaysBeforeToday: {
    name: "Enforce max days before today",
    fn: "enforceMaxDaysBeforeToday",
    // onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      maxBeforeToday: {
        type: "number",
        value: 0,
        label: "Max Days Before Today"
      }
    })
  },
  enforceMaxDaysAfterToday: {
    name: "Enforce max days after today",
    fn: "enforceMaxDaysAfterToday",
    // onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      maxAfterToday: { type: "number", value: 0, label: "Max Days After Today" }
    })
  },
  enforceMaxMonthsBeforeToday: {
    name: "Enforce max months before today",
    fn: "enforceMaxMonthsBeforeToday",
    // onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      maxBeforeToday: {
        type: "number",
        value: 0,
        label: "Max Months Before Today"
      }
    })
  },
  enforceMaxMonthsAfterToday: {
    name: "Enforce max months after today",
    fn: "enforceMaxMonthsAfterToday",
    // onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      maxAfterToday: { type: "number", value: 0, label: "Max Months After Today" }
    })
  },
  enforceMinDaysBeforeToday: {
    name: "Enforce min days before today",
    fn: "enforceMinDaysBeforeToday",
    // onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      minBeforeToday: {
        type: "number",
        value: 0,
        label: "Min Days Before Today"
      }
    })
  },
  enforceMinDaysAfterToday: {
    name: "Enforce min days after today",
    fn: "enforceMinDaysAfterToday",
    // onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      minAfterToday: { type: "number", value: 0, label: "Min Days After Today" }
    })
  },
  enforceMinMonthsBeforeToday: {
    name: "Enforce min months before today",
    fn: "enforceMinMonthsBeforeToday",
    // onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      minBeforeToday: {
        type: "number",
        value: 0,
        label: "Min Months Before Today"
      }
    })
  },
  enforceMinMonthsAfterToday: {
    name: "Enforce min months after today",
    fn: "enforceMinMonthsAfterToday",
    // onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      minAfterToday: { type: "number", value: 0, label: "Min Months After Today" }
    })
  },
  enforceSignatureDateRange: {
    name: "Enforce max date range for signatures",
    fn: "enforceSignatureDateRange",
    // onChange: true,
    onBlur: true,
    onAdvance: true,
    props: getProps({
      maxAfterToday: {
        type: "number",
        value: 0,
        label: "Max Days After Today"
      },
      maxBeforeToday: {
        type: "number",
        value: 0,
        label: "Max Days Before Today"
      }
    })
  },
  dateRangeRequired: {
    name: 'Date Range Required',
    fn: 'dateRangeRequired',
    onAdvance: true,
    props: getProps()
  },
  minDate: {
    name: "Minimum date",
    fn: "minDate",
    onBlur: true,
    onAdvance: true,
    props: getProps({
      minDateOptions: {
        type: "genericServerOptions",
        value: "custom",
        label: "Minimum date source",
        staticOptions: [{ value: "custom", label: "Custom" }],
        getOptionsFunction: getDateOptions
      },
      customMinDate: {
        type: "date",
        value: null,
        label: "Custom minimum date",
        getOptionsFunction: getDateOptions
      }
    })
  },
  maxDate: {
    name: "Maximum date",
    fn: "maxDate",
    onAdvance: true,
    props: getProps({
      maxDateOptions: {
        type: "genericServerOptions",
        value: "custom",
        label: "Maximum date source",
        staticOptions: [{ value: "custom", label: "Custom" }]
      },
      customMaxDate: {
        type: "date",
        value: null,
        label: "Custom maximum date"
      }
    })
  },
  minDateRange: {
    name: "Minimum date",
    fn: "minDateRange",
    onAdvance: true,
    props: getProps({
      minDateOptions: {
        type: "genericServerOptions",
        value: "custom",
        label: "Minimum date source",
        staticOptions: [{ value: "custom", label: "Custom" }],
        getOptionsFunction: getDateOptions
      },
      customMinDate: {
        type: "date",
        value: null,
        label: "Custom minimum date",
        getOptionsFunction: getDateOptions
      }
    })
  },
  maxDateRange: {
    name: "Maximum date",
    fn: "maxDateRange",
    onAdvance: true,
    props: getProps({
      minDateOptions: {
        type: "genericServerOptions",
        value: "custom",
        label: "Maximum date source",
        staticOptions: [{ value: "custom", label: "Custom" }]
      },
      customMaxDate: {
        type: "date",
        value: null,
        label: "Custom maximum date"
      }
    })
  },
  validZipCode: {
    name: "Must be a correctly formatted Postal code",
    fn: "validZipCode",
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  validAddressZipCode: {
    name: "Must be a correctly formatted Postal code",
    fn: "validAddressZipCode",
    onAdvance: true,
    props: getProps()
  },
  props: getProps({
    maxAfterToday: { type: "number", value: 0, label: "Max Days After Today" }
  }),
  validSocial: {
    name: "Must be a correctly formatted social security number",
    fn: "validSocial",
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  enforceUploadPlaceholderRules: {
    name: "Enforce Upload Placeholder Rules",
    fn: "enforceUploadPlaceholderRules",
    onAdvance: true,
    props: {}
  },
  uploadRequired: {
    name: "Upload is required",
    fn: "uploadRequired",
    deferred: true,
    props: {}
  },
  uploadImmediatelyRequired: {
    name: "Upload is required",
    fn: "uploadImmediatelyRequired",
    onAdvance: true,
    onBlur: true,
    props: {}
  },
  allSignaturesRequired: {
    name: "All signatures are required",
    fn: "allSignaturesRequired",
    onAdvance: true,
    props: getProps()
  },
  minRequiredSignatures: {
    name: "A minimum number of signatures are required",
    fn: "minRequiredSignatures",
    onAdvance: true,
    props: getProps({
      minRequiredSignatures: {
        type: "number",
        value: 1,
        label: "Minimum Required Signatures"
      }
    })
  },
  signaturesMinLength: {
    name: "A minimum number of characters for signatures and behalf of are required",
    fn: "signaturesMinLength",
    onAdvance: true,
    props: getProps({
      signaturesMinLength: {
        type: "number",
        value: 3,
        label: "Minimum length of signatures"
      }
    })
  },
  formationLocaleRequired: {
    name: "Formation locale is required",
    fn: "formationLocaleRequired",
    onAdvance: true,
    props: getProps()
  },
  validateEntityNameFields: {
    name: "Validate Entity Name Fields",
    fn: "validateEntityNameFields",
    onAdvance: true,
    onBlur: true,
    props: {
      mustSelectReservedName: {
        type: "checkbox",
        value: true,
        label: `If filing with a reserved name, a name must be selected.`
      },
      entityNameRequired: {
        type: "checkbox",
        value: true,
        onBlur: true,
        label: `If not using a reserved name, entity name is required.`
      },
      mustSelectAdditionalName: {
        type: "checkbox",
        value: true,
        label: "If filing Trade/Fictitious name, a name must be selected."
      },
      numConsentsRequired: {
        type: "checkbox",
        value: true,
        label: "If consent required, must provide number of consents."
      },
      disableNameNotTakenCheck: {
        type: "checkbox",
        value: false,
        label: "Disable name uniqueness check"
      },
      filingTypeId: {
        type: "fieldSrc",
        value: "",
        label: "Override FILING_TYPE_ID with value from field:",
        emptyOptionLabel: "[Use default FILING_TYPE_ID]"
      },
      filingSubtypeId: {
        type: "fieldSrc",
        value: "",
        label: "Override FILING_SUBTYPE_ID with value from field:",
        emptyOptionLabel: "[Use default FILING_SUBTYPE_ID (0)]"
      }
    }
  },
  poBoxNotAllowed: {
    name: "PO Box Not Allowed",
    fn: "poBoxNotAllowed",
    onAdvance: true,
    props: getProps()
  },
  isValidName: {
    name: "Must be a valid entity name",
    fn: "isValidName",
    onAdvance: true,
    onBlur: true,
    props: getProps({
      filingTypeId: {
        type: "fieldSrc",
        value: "",
        label: "Override FILING_TYPE_ID with value from field:",
        emptyOptionLabel: "[Use default FILING_TYPE_ID]"
      },
      filingSubtypeId: {
        type: "fieldSrc",
        value: "",
        label: "Override FILING_SUBTYPE_ID with value from field:",
        emptyOptionLabel: "[Use default FILING_SUBTYPE_ID]"
      }
    })
  },
  mailingAddressIsRequired: {
    name: "Full mailing address is required",
    fn: "mailingAddressIsRequired",
    onAdvance: true,
    props: getProps()
  },
  mailingAddressIsValid: {
    name: "Mailing address must be a valid USPS address if add new agent",
    fn: "mailingAddressIsValid",
    onAdvance: true,
    props: getProps()
  },
  partialMailingAddressNotAllowed: {
    name: "Partial mailing addresses are not allowed",
    description:
      "This rule has the effect of disallowing a partially completed address, but will allow an empty address. Cannot be used with AMS address validation rules.",
    fn: "partialMailingAddressNotAllowed",
    onAdvance: true,
    props: getProps()
  },
  mailingPoBoxNotAllowed: {
    name: "Mailing address PO Box not allowed",
    fn: "mailingPoBoxNotAllowed",
    onAdvance: true,
    props: getProps()
  },
  repeaterColumnsMustBeUnique: {
    name: "Repeater values must be unique",
    fn: 'repeaterColumnsMustBeUnique',
    onAdvance: true,
    props: {
      constraints: {
        type: 'constraints',
        value: []
      }
    }
  },
  isValidEmailFormat: {
    name: "Must be a correctly formatted email address",
    fn: "isValidEmailFormat",
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  timeRequired: {
    name: "Time is required",
    fn: 'timeRequired',
    onBlur: true,
    onAdvance: true,
    props: getProps()
  },
  uccSearchRequired: {
    fn: 'uccSearchRequired',
    name: 'UCC search is required',
    onAdvance: true,
    props: {}
  },
  atLeastOneUccSearchResultIsRequired: {
    fn: 'atLeastOneUccSearchResultIsRequired',
    name: 'At least one search result is required',
    onAdvance: true,
    props: getProps({
      onlyAppliesToFileNumber: {
        type: 'checkbox',
        label: 'Only applies to File Number search',
        value: false
      },
      onlyRequireWhenExists: {
        type: 'checkbox',
        label: 'Only require when results exist',
        value: false
      }
    })
  },
  mustSelectLocalSelect: {
    fn: 'mustSelectLocalSelect',
    name: 'Must select an option',
    onAdvance: true,
    onBlur: true,
    props: getProps()
  },
  enforceRepeaterChildConstraints: {
    fn: 'enforceRepeaterChildConstraints',
    name: "Enforce column constraints",
    onAdvance: true,
    props: {}
  },
  minMultiComplete: {
    fn: 'minMultiComplete',
    name: 'A minimum number of selections is required',
    onAdvance: true,
    props: getProps({
      min: {
        type: 'range',
        value: 1,
        minValue: 1,
        maxValue: 50,
        step: 1
      }
    })
  },
  efsRequired: {
    fn: 'efsRequired',
    name: 'Must provide crop years',
    onAdvance: true,
    props: {
      errorMessage: { type: "text", value: "", label: "Crop years error message" },
      durationErrorMessage: { type: "text", value: "", label: "Specified year through duration error message" },
      arbitraryErrorMessage: { type: "text", value: "", label: "Specified years error message" }
    }
  },
  mayOnlyAddAdditionalRows: {
    fn: 'mayOnlyAddAdditionalRows',
    name: 'May only add X additional rows',
    onAdvance: true,
    props: getProps({
      numRows: { type: 'range', value: 1, step: 1, minValue: 1, maxValue: 100, label: 'Number of additional rows'}
    })
  },
  mustHaveSameNumRowsAs: {
    fn: 'mustHaveSameNumRowsAs',
    name: 'Must have the same number of rows as another repeater',
    onAdvance: true,
    props: getProps({
      repeater: {
        type: 'fieldSrc',
        emptyOptionLabel: '[Select a repeater]',
        value: "",
        label: "Select a repeater",
        props: {excludeSelf: true, allowedTypes: ['repeater']}
      }
    })
  },
  onlyNumbers: {
    fn: 'onlyNumbers',
    name: 'Only allow numbers',
    onAdvance: true,
    onBlur: true,
    props: getProps({
      allowCommas: {
        type: 'checkbox',
        value: false,
        label: "Allow Commas"
      }
    })
  },
  maxCharacters: {
    fn: 'maxCharacters',
    name: 'Only allow a maximum number of characters',
    onAdvance: true,
    onBlur: true,
    props: getProps({
      maxCharacters: {
        label: "Maximum number of characters",
        type: 'number',
        value: 100
      }
    })
  },
  minCharacters: {
    fn: 'minCharacters',
    name: 'Require a minimum number of characters',
    onAdvance: true,
    onBlur: true,
    props: getProps({
      minCharacters: {
        label: "Minimum number of characters",
        type: 'number',
        value: 100
      }
    })
  },
  minRepeaterEdit: {
    fn: 'minRepeaterEdit',
    name: 'Must edit at least X rows',
    onAdvance: true,
    props: getProps({
      minRows: {
        label: "Minimum number of edited rows",
        type: 'number',
        value: 1
      }
    })
  },
  minRepeaterDelete: {
    fn: 'minRepeaterDelete',
    name: 'Must delete at least X rows',
    onAdvance: true,
    props: getProps({
      minRows: {
        label: "Minimum number of deleted rows",
        type: 'number',
        value: 1
      },
      disableIfOne: {
        label: "Disable this rule if only 1 row.",
        type: "checkbox",
        value: false
      }
    })
  },
  checkForRegulatedWords: {
    fn: 'checkForRegulatedWords',
    name: "Check for regulated words",
    onAdvance: true,
    props: getProps({
      regulatedWordLists: {
        label: "Select which word lists to check against for regulated words.",
        type: 'regulatedWords',
        value: []
      }
    })
  },
  customBusinessRules: {
    fn: 'customBusinessRules',
    name: "Custom business rules",
    onAdvance: true,
    props: ({
      rules: {
        type: "customBusinessRules",
        value: [],
        allowCurrentRepeaterFields: false,
        allowCurrentField: true
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/businessRules.js